import { Injectable } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { ILeadNumberProvider } from 'sharedModels/interfaces/leadNumberProvider';
import { selectLeadNumber } from 'stores/quote/quote.selectors';

@UntilDestroy()
@Injectable({
    providedIn: 'root',
})
export class QuoteLeadNumberProviderService implements ILeadNumberProvider {
    constructor(private readonly store: Store) {}

    getLeadNumber(): string | undefined {
        return this.store.selectSignal(selectLeadNumber)() ?? undefined;
    }
}
